import { defineType } from "sanity";
import { multilingualArrayBlockContent, packageIcon } from "../base";
import { multilingualBlockContentPreview } from "../base/multilingualArrayBlockContent";

export default defineType({
  name: "asPromoFeaturedCard",
  title: "Render as Promo Featured Card",
  options: {
    collapsible: true,
    collapsed: true
  },
  type: "object",
  fieldsets: [
    {
      name: "icon",
      title: "Icon",
      options: { collapsible: true, collapsed: true }
    }
  ],
  fields: [
    {
      fieldset: "icon",
      title: "Icon",
      name: "icon",
      type: packageIcon.name,
      validation: (Rule) => Rule.required()
    },
    {
      fieldset: "icon",
      title: "Icon Title",
      name: "iconTitle",
      type: multilingualArrayBlockContent.name
    },
    {
      fieldset: "icon",
      title: "Icon Subtitle",
      name: "iconSubtitle",
      type: multilingualArrayBlockContent.name
    },
    {
      name: "title",
      title: "Card Title",
      description:
        "When set, the card will use this title instead of the main page title.",
      type: multilingualArrayBlockContent.name,
      validation: (Rule) => Rule.required()
    },
    {
      name: "description",
      title: "Description on Card",
      description: "Content to appear in the card, below the title",
      type: multilingualArrayBlockContent.name
    }
  ],
  toReadableText: (card: any) =>
    multilingualBlockContentPreview(100)(card?.title)
});
